export const DaysOfWeek = [
	{ value: "Monday", short: "Mon" },
	{ value: "Tuesday", short: "Tue" },
	{ value: "Wednesday", short: "Wed" },
	{ value: "Thursday", short: "Thu" },
	{ value: "Friday", short: "Fri" },
	{ value: "Saturday", short: "Sat" },
	{ value: "Sunday", short: "Sun" },
];

export const Weekdays = [
	"Monday",
	"Tuesday",
	"Wednesday",
	"Thursday",
	"Friday",
];
